import React from "react"
import { ShieldExclamationIcon } from "@heroicons/react/24/outline"
import { useNavigate } from "react-router-dom"
import Button from "../ui/Button"

const Unauthorized: React.FC = () => {
    const navigate = useNavigate()

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-lg w-full space-y-8">
                <div className="text-center">
                    <ShieldExclamationIcon className="mx-auto h-12 w-12 text-red-500" />
                    <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                        Access Denied
                    </h2>
                    <p className="mt-2 text-sm text-gray-600">
                        You don't have permission to access this page. Please contact your account Administrator if you need to update your account permissions
                    </p>
                </div>
                <div className="mt-8 space-y-6">
                    <div className="text-center">
                        <Button variant="blue"
                            onClick={() => window.location.href = `${window.origin}/admin/reservations`}
                            size="large"
                            className="w-full"
                        >
                            Go to Reservations
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Unauthorized 